export default __webpack_public_path__ + "static/media/Gauntlets of the Beyond.36f0555e.jpg";